<template>
  <div>
    <Form ref="searchForm" inline :label-width="70">
      <FormItem label="申请时间">
        <DatePicker
          type="daterange"
          placeholder="开始时间~截止时间"
          ref="askTime"
          v-model="applyTime"
          @on-change="onApplyTimeChange"
          style="width: 200px"
        ></DatePicker>
      </FormItem>
      <FormItem label="审核时间">
        <DatePicker
          type="daterange"
          placeholder="开始时间~截止时间"
          ref="askTime"
          v-model="verifyTime"
          @on-change="onVerifyTimeChange"
          style="width: 200px"
        ></DatePicker>
      </FormItem>
      <Form-item label="审核状态">
        <Select v-model="searchCondition.status"
        style="width: 200px">
          <Option label="全部"></Option>
          <Option v-for="(item,index) in status" :label="item" :value="index"></Option>
        </Select>
      </Form-item>
      <Form-item label="用户">
        <Input
          style="width:200px"
          placeholder="请输入姓名"
          v-model="searchCondition.real_name"
          clearable
          @keydown.native.enter="search(1)"
        />
      </Form-item>
      <Form-item label="手机号">
        <Input
          style="width:200px"
          placeholder="请输入手机号"
          v-model="searchCondition.mobile"
          clearable
          @keydown.native.enter="search(1)"
        />
      </Form-item>

      <Form-item class="search-form-btns">
        <div class="btn-wrap form-item-search">
          <Button icon="ios-search" @click="search(1)">搜索</Button>
          <Button icon="md-undo" @click="search(0)">重置</Button>
        </div>
      </Form-item>
    </Form>
    <div class="content">
      <Grid
        ref="grid"
        :columns="columns"
        data-url="/api/ask/ask/transferList"
        :search="searchCondition"
        :rowsFormatter="rowsFormatter"
        keyField="id"
        method="get"
      >
        <template slot-scope="{ row }" slot="action">
          <Button type="text" size="small" @click="showAuditDetail(row.transfer_id)">详情</Button>
          <Button type="text" size="small" v-if="row.status == 3" @click="showAudit(row.transfer_id)">- 审核</Button>
        </template>
      </Grid>
    </div>
    <Modal class="modal" v-model="showAuditModal" title="提现审核">
      <Form ref="auditForm" :model="transferInfo" :rules="auditRules" :label-width="120">
        <FormItem label="提现单号" prop="transfer_number">{{transferInfo.transfer_number}}</FormItem>
        <FormItem label="用户名" prop="nickname">{{transferInfo.nickname}}</FormItem>
        <FormItem label="手机号" prop="mobile">{{transferInfo.u_mobile}}</FormItem>
        <FormItem label="申请时间" prop="create_at">{{transferInfo.create_at}}</FormItem>
        <FormItem label="提现方式" prop="account_type">{{account_type[transferInfo.account_type]}}</FormItem>
        <FormItem label="真实姓名" prop="real_name">{{transferInfo.real_name}}</FormItem>
        <FormItem label="提现账户" prop="account_no">{{transferInfo.account_no}}</FormItem>
        <FormItem label="提现申请额" style="color:red" prop="amount">￥{{transferInfo.amount/100}}</FormItem>
        <FormItem label="账户余额" prop="balance">￥{{transferInfo.balance/100}}</FormItem>
        <FormItem label="审核原因" prop="remark">
          <Input v-model="transferInfo.remark" type="textarea"
            placeholder="请输入备注" :rows="3" :maxlength="500"
          ></Input>
        </FormItem>
      </Form>
      <template v-slot:footer>
        <Button type="primary" @click="confirmAudit(1)">通过</Button>
        <Button type="default" @click="confirmAudit(2)">拒绝</Button>
      </template>
    </Modal>

    <Modal class="modal" v-model="showAuditModalDetail" title="提现审核">
      <Form :model="transferInfo" :label-width="120">
        <FormItem label="提现单号" prop="transfer_number">{{transferInfo.transfer_number}}</FormItem>
        <FormItem label="用户名" prop="nickname">{{transferInfo.nickname}}</FormItem>
        <FormItem label="手机号" prop="mobile">{{transferInfo.u_mobile}}</FormItem>
        <FormItem label="申请时间" prop="create_at">{{transferInfo.create_at}}</FormItem>
        <FormItem label="提现方式" prop="account_type">{{account_type[transferInfo.account_type]}}</FormItem>
        <FormItem label="真实姓名" prop="real_name">{{transferInfo.real_name}}</FormItem>
        <FormItem label="提现账户" prop="account_no">{{transferInfo.account_no}}</FormItem>
        <FormItem label="提现申请额" style="color:red" prop="amount">￥{{transferInfo.amount/100}}</FormItem>
        <FormItem label="账户余额" prop="balance">￥{{transferInfo.balance/100}}</FormItem>
        <FormItem label="审核状态" prop="status">{{status[transferInfo.status]}}</FormItem>
        <FormItem label="审核时间" prop="audit_at">{{transferInfo.audit_at}}</FormItem>
        <FormItem label="审核原因" prop="audit_at">{{transferInfo.remark}}</FormItem>
      </Form>
      <template v-slot:footer>
        <Button type="primary" @click="showAuditModalDetail = false">关闭</Button>
      </template>
    </Modal>
  </div>
</template>
<script>
export default {
  name: "WithdrawManage",
  data() {
    return {
      status: {
        1: '通过',
        2: '未通过',
        3: '待审核'
      },
      account_type: {
        1: '支付宝'
      },
      searchCondition: {
        apply_start_time: "",
        apply_end_time: "",
        verify_start_time: "",
        verify_end_time: "",
        status: "",
        real_name: "",
        mobile: ""
      },
      columns: [
        {
          title: "提现单号",
          key: "transfer_number",
          minWidth: 180
        },
        {
          title: "用户",
          key: "real_name",
          minWidth: 140,
          align: 'center'
        },
        {
          title: "手机号",
          key: "mobile",
          minWidth: 120,
          align: 'center'
        },
        {
          title: "账户余额",
          key: "balance",
          minWidth: 90,
          align: 'center'
        },
        {
          title: "申请提现额",
          key: "amount",
          minWidth: 100,
          align: 'center'
        },
        {
          title: "申请日期",
          key: "create_at",
          minWidth: 150,
          align: 'center'
        },
        {
          title: "审核日期",
          key: "audit_at",
          minWidth: 150,
          align: 'center'
        },
        {
          title: "回复状态",
          key: "status_text",
          minWidth: 100,
          align: 'center'
        },
        {
          title: "操作",
          slot: "action",
          width: 120,
          align: "center",
          fixed: "right"
        }
      ],
      applyTime: [],
      verifyTime: [],
      showAuditModal: false,
      showAuditModalDetail: false,
      auditRules: {
        remark: [{ required: true, message: "审核原因" }]
      },
      transferInfo: {

      }
    };
  },
  async created() {
  },
  methods: {
    onApplyTimeChange(range) {
      this.searchCondition.apply_start_time = range[0];
      this.searchCondition.apply_end_time = range[1];
    },
    onVerifyTimeChange(range) {
      this.searchCondition.verify_start_time = range[0];
      this.searchCondition.verify_end_time = range[1];
    },
    rowsFormatter(rows) {
      rows.forEach(row => {
          row.status_text = this.status[row.status]
          row.balance = '￥' + row.balance/100
          row.amount = '￥' + row.amount/100
      });
    },
    onSelectionChange(list) {
      this.selectList = list;
    },
    search(flag) {
      if (flag == 0) {
        this.searchCondition.apply_start_time = "";
        this.searchCondition.apply_end_time = "";
        this.searchCondition.verify_start_time = "";
        this.searchCondition.verify_end_time = "";
        this.searchCondition.status = "";
        this.searchCondition.real_name = "";
        this.searchCondition.mobile = "";
        this.applyTime=[];
        this.verifyTime= [];
      } else {

      }
      this.$refs.grid.searchRefresh();
    },
    showAudit(id) {
      this.$http.get("/api/ask/ask/transferInfo",{ transfer_id: id }).then( res => {
          this.transferInfo = res
          this.showAuditModal = true
      });
    },
    showAuditDetail(id) {
      this.$http.get("/api/ask/ask/transferInfo",{ transfer_id: id }).then( res => {
          this.transferInfo = res
          this.showAuditModalDetail = true
      });
    },
    confirmAudit(status) {
      this.$refs.auditForm.validate(valid => {
        if (!valid) return;
        this.$http.post("/api/ask/ask/verify",{
          transfer_id: this.transferInfo.transfer_id,
          status,
          remark: this.transferInfo.remark,
          user_id: this.transferInfo.user_id,
        }).then( res => {
            this.showAuditModal = false;
            this.$refs.grid.searchRefresh();
        });
      });
    }
  }
};
</script>
